import React from 'react';
import PropTypes from 'prop-types';
import Switch from './ui/Switch';

class ProductModalDetails extends React.Component{


    render() {
        return (
            <div className="tab-panel">
                <div className="column">
                    <label htmlFor="productTitle">Title</label>
                    <input id="productTitle" defaultValue={this.props.product.title} onChange={e => this.props.updateProduct("title", e.target.value)} placeholder="Enter title" />
                    <Switch checked={this.props.product.progressBar === "true"} label="Show progress bar" onChange={checked => this.props.updateProduct("progressBar", checked) } />
                </div>

                <div className="column">
                    <Switch checked={this.props.product.circleContent === "true"} label="Circle content" onChange={checked => this.props.updateProduct("circleContent", checked) } />
                    <Switch checked={this.props.product.gettingStarted === "true"} label="Getting started" onChange={checked => this.props.updateProduct("gettingStarted", checked) } />
                    <Switch checked={this.props.product.deepDiveCourse === "true"} label="Deep dive course" onChange={checked => this.props.updateProduct("deepDiveCourse", checked) } />
                    <Switch checked={this.props.product.midasRecovery === "true"} label="Midas Recovery" onChange={checked => this.props.updateProduct("midasRecovery", checked) } />
                    <Switch checked={this.props.product.violetFlame === "true"} label="Violet Flame" onChange={checked => this.props.updateProduct("violetFlame", checked) } />
                </div>
            </div>
        );
    }
}

ProductModalDetails.propTypes = {
    product: PropTypes.object.isRequired,
    updateProduct: PropTypes.func.isRequired
}

export default ProductModalDetails;


/** WEBPACK FOOTER **
 ** ./src/components/ProductModalDetails.js
 **/